export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const CREATE_USER = 'CREATE_USER';
export const CLEAR_AUTH_STATE = 'CLEAR_AUTH_STATE';
export const REDIRECT_TO_HOME = 'REDIRECT_TO_HOME';